import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const WorkCaseSubNav = () => {
  const location = useLocation();
  const inWorkCases = location.pathname.startsWith('/work-cases');
  if (!inWorkCases) return null;

  const tabs = [
    { label: 'Thống kê', to: '/work-cases/stats' },
    { label: 'Tôi đã giao', to: '/work-cases/created' },
    { label: 'Được giao cho tôi', to: '/work-cases/assigned' }
  ];

  const isActive = (to) => location.pathname === to;

  return (
    <div className="mb-4">
      <div className="inline-flex rounded-lg border border-gray-200 overflow-hidden">
        {tabs.map((t, idx) => (
          <Link
            key={t.to}
            to={t.to}
            className={`${idx !== 0 ? 'border-l border-gray-200' : ''} px-4 py-2 text-sm font-medium ${
              isActive(t.to) ? 'bg-blue-600 text-white' : 'bg-white text-gray-700 hover:bg-gray-50'
            }`}
          >
            {t.label}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default WorkCaseSubNav;


